import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import 'react-image-lightbox/style.css';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import {
    Tabs,
    Title,
    TitleSymbol,
    Wrapper,
    Record,
    RecordContent,
    RecordLabel,
    Source,
    Embed,
    EmbedContent,
} from './ConferenceReportageVideo.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferenceReportageVideoTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.REPORTAGEVIDEO}`} colors={colors}>
            <Title colors={colors}>
                {t('conference.component.reportagevideo.title')} <TitleSymbol colors={colors} />
            </Title>

            {conf?.conference?.url_youtube && (
                <>
                    <Record>
                        <RecordContent>
                            <EmbedContent>
                                <Embed src={conf?.conference?.url_youtube}></Embed>
                            </EmbedContent>
                        </RecordContent>
                    </Record>

                    <Source>{t('conference.general.sourcePP')}</Source>
                </>
            )}
        </Wrapper>
    );
};

export default ConferenceReportageVideoTemplate;
